import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Amplify } from 'aws-amplify';
import App from './app/App';
import store from './store/store';
import cognitoConfig from './shared/config/cognitoConfig';
import { ENV } from './shared/constants';
import './shared/styles/tailwind.css';
import '@bafkal/ui-shared/styles';


// Configure Amplify with values set in `src/config/cognitoConfig.js`
// If oauth is partially configured, do not include the oauth config
const configToUse = {
  ...cognitoConfig,
  Auth: {
    ...cognitoConfig.Auth,
    ...(cognitoConfig.Auth && cognitoConfig.Auth.oauth ? { oauth: { ...cognitoConfig.Auth.oauth } } : {})
  }
};
if (configToUse && configToUse.Auth && configToUse.Auth.oauth) {
  const oauth = configToUse.Auth.oauth;
  const hasIncompleteConfig =
    !configToUse.Auth.userPoolId ||
    !configToUse.Auth.userPoolWebClientId ||
    !oauth.domain;

  if (hasIncompleteConfig) {
    if (ENV.IS_DEVELOPMENT) {
      console.warn(
        'Incomplete Cognito OAuth configuration detected; stripping oauth settings to avoid runtime OAuth errors. Fill REACT_APP_COGNITO_* environment variables to enable Managed Login.'
      );
    }
    delete configToUse.Auth.oauth;
  }
}

Amplify.configure(configToUse);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);